export default __webpack_public_path__ + "static/media/android.312f8a85.svg";